import React from "react";
import { LegalPageLayout } from "./LegalPageLayout";

// TODO: заменить плейсхолдеры на согласованный юристами текст политики конфиденциальности.
const sections = [
  {
    heading: "1. Общие положения",
    text: "[Место для текста: описание того, кто является оператором персональных данных, на основании каких документов действует политика, к каким отношениям она применяется.]",
  },
  {
    heading: "2. Какие данные мы собираем",
    text: "[Место для текста: перечень собираемых данных — имя, телефон, email, файлы cookie, данные аналитики и т.д.]",
  },
  {
    heading: "3. Цели обработки данных",
    text: "[Место для текста: для чего используются данные — обработка заявок, обратная связь, аналитика, улучшение сайта.]",
  },
  {
    heading: "4. Использование файлов cookie",
    text: "[Место для текста: какие cookie используются, для чего, как пользователь может их отключить в настройках браузера.]",
  },
  {
    heading: "5. Передача данных третьим лицам",
    text: "[Место для текста: передаются ли данные третьим лицам, при каких условиях, каким сервисам.]",
  },
  {
    heading: "6. Хранение и защита данных",
    text: "[Место для текста: сроки хранения данных, меры по их защите.]",
  },
  {
    heading: "7. Права пользователя",
    text: "[Место для текста: право на доступ, изменение, удаление своих данных и порядок обращения.]",
  },
  {
    heading: "8. Контакты",
    text: "[Место для текста: контактные данные оператора для вопросов по обработке персональных данных.]",
  },
];

const PrivacyPolicy = () => (
  <LegalPageLayout
    title="Политика конфиденциальности"
    updatedAt="[Дата последнего обновления]"
    sections={sections}
  />
);

export default PrivacyPolicy;
